module.exports = __webpack_public_path__ + "img/couples-084.110fa114.jpg";